import { render, staticRenderFns } from "./SearchResultsBarChart.vue?vue&type=template&id=261e2b5e&scoped=true&"
import script from "./SearchResultsBarChart.vue?vue&type=script&lang=js&"
export * from "./SearchResultsBarChart.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsBarChart.vue?vue&type=style&index=0&id=261e2b5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261e2b5e",
  null
  
)

export default component.exports